window.BaseForm = function(name, scope) {
    var self = this;
    var _protected = {};

    self.data = {};
    self.name = name;
    self.status = {};

    self.passwordStrength = {};

    var _scope = scope;

    self.validator = new FormValidator(name);

    var events = {
        "on-view-loaded": [],
        "on-form-saved": []
    };

    self.validator.afterValidation(function() {
        if (scope) {
            try {
                scope.$digest();
            }
            catch (e) { /* Do Nothing */ }
        }
        else {
            console.warn("Scope is not here: form name: ", name);
        }
    });

    _protected.trigger = function(eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function(handler){
            handler(param1, param2, param3, param4);
        });
    }

    self.syncScope = function () {
        try {
            scope.$digest();
        }
        catch (e) { /* Do Nothing */ }
    };

    self.triggerFormSaved = function (args0) {
        _protected.trigger("on-form-saved", args0);
    };

    self.onFormSaved = function (eventHandler) {
        events['on-form-saved'].push(eventHandler);
    };

    self.onFormViewLoaded = function (eventHandler) {
        events['on-view-loaded'].push(eventHandler);
    };

    self.onViewLoaded = function() {
        self.validator.listenForValidation();
        self.formViewLoaded = true;
        self.validator.formLoaded = true;
        _protected.trigger("on-view-loaded");
    }

    self.load = function() {
        console.warn("Load is not implemented for this form", self.name);
    }

    self.save = function() {
        console.warn("Save is not implemented for this form", self.name);
    }

    /**
     * This function used on the dynamic forms 'schema_form.html' to check the visibility for elements
     */
    self.checkFieldVisibilityForSchemaForm = function(field) {
        var shown = true;
        var modelValue;

        if (typeof field['hidden_if'] !== 'undefined') {
            modelValue = self.data[field['hidden_if']['model']];
            shown &= (typeof modelValue !== 'undefined' && modelValue !== field['hidden_if']['value']);
        }

        if (typeof field['hidden_if_not'] !== 'undefined') {
            modelValue = self.data[field['hidden_if_not']['model']];
            shown &= (typeof modelValue !== 'undefined' && modelValue === field['hidden_if_not']['value']);
        }

        return shown;
    };

    self.checkFieldVisibilityForDocumentsSchemaForm = function (field) {
        var shown = true;
        var modelValue;

        if (typeof field['hidden_if'] !== 'undefined') {
            modelValue = self.data[field['hidden_if']['model']];
            if (Array.isArray(field['hidden_if']['value'])) {

                shown &= (typeof modelValue !== 'undefined' && field['hidden_if']['value'].indexOf(modelValue) == -1);

            } else {
                shown &= (typeof modelValue !== 'undefined' && modelValue !== field['hidden_if']['value']);
            }
        }

        if (typeof field['hidden_if_not'] !== 'undefined') {
            modelValue = self.data[field['hidden_if_not']['model']];

            if (Array.isArray(field['hidden_if_not']['value'])) {

                shown &= (typeof modelValue !== 'undefined' && field['hidden_if_not']['value'].indexOf(modelValue) > -1);

            } else {
                shown &= (typeof modelValue !== 'undefined' && modelValue === field['hidden_if_not']['value']);
            }
        }

        return shown;
    };

    return _protected;
}

BaseForm.VALIDATION_ERROR = "validationError";
